import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0012',
    ecrans: ['00-2'],
    params: ['id',
            '?niveau',
            '?elecleint',
            '?soncleint',
            '?vaesysnatctb',
            '?anncivfin',
            '?peccoddeb',
            '?peccodfin',
            '?indcleint']
});
